import React, { useContext, useState, useEffect } from 'react';

import SideInfo from '../../Components/sideInfo';
import LatestBuilds from '../../Components/latestBuilds';
import HomepageHeader from '../template/header/homepage';
import SearchPokemonForm from '../../Components/forms/searchPokemon';
import { AppConfigContext } from '../../Config/App';
import LoadingAnimation from '../../Components/loadingAnimation';

const Homepage = ({classes}) => {
    const { uri_segment } = useContext(AppConfigContext);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    if (!isLoaded) {
        return <LoadingAnimation />
    } else {
        return (
            <div className={classes}>
                <div className='d-flex flex-wrap'>
                    <HomepageHeader />
                    <SideInfo classes="purple-bk mb-4 pb-3 d-none d-lg-block col-12 col-sm-4 col-xl-4 col-xxl-3 pe-lg-2 pe-xl-3">
                        <SearchPokemonForm isHomepage={true} dismiss={uri_segment() === "new-build" ? "offcanvas" : ''} />
                    </SideInfo>
                    <LatestBuilds />
                </div>
            </div>
        );
    }
}
export default Homepage;